















import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component({
  name: 'BaseToggle',
})
export default class BaseToggle extends Vue {
  @Model('toggle', { default: false }) value: boolean;
  @Prop({ default: false }) disabled: boolean;

  toggleValue() {
    if (this.disabled) {
      return;
    }
    this.$emit('toggle', !this.value);
  }
}
